import { Box, Typography, styled } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import Logo from 'assets/BF-VendorsLogo.png';

const StyledImage = styled('img')(({ theme }) => ({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    width: '250px',
  },
  [theme.breakpoints.up('md')]: {
    width: '500px',
  },
}));

function ContentWrapper({ title, children }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <StyledImage src={Logo} alt={t('login.bonfire_logo')} />
      <Box pb={4}>
        <Typography variant="h1" component="h1" align="center">
          {t('login.app_description')}
        </Typography>
      </Box>
      <Box py={6} px={8}>
        <Typography variant="h2" align="center">
          {title}
        </Typography>
        {children}
      </Box>
    </Box>
  );
}

export default ContentWrapper;
